<div class="bg-white p-4 w-full">
  <h1 class="tracking-tight border-b border-primary-600 pb-6">
    {{ { key: 'cart' } | i18n }}
  </h1>
  @if (cart.observeIsCartLoading() | async) {
    <section class="mt-12 rounded-lg p-4">
      <app-loading></app-loading>
    </section>
  } @else if (website.observeAuthenticated() | async) {
    @if (cart.observePositions() | async; as positions) {
      @if (positions && positions.length > 0) {
        <form class="mt-12 w-full">
          <section aria-labelledby="cart-heading" class="mb-6">
            <ul role="list" class="divide-y divide-gray-200 border-b border-gray-200 last:border-b-0">
              @for (pos of positions; track pos._id; let i = $index) {
                <li class="flex flex-col md:flex-row gap-4">
                  <div class="h-full w-full md:w-48 flex flex-col justify-center items-center">
                    <div class="mr-6 h-32 w-48 max-h-32 max-w-48 mt-8">
                      <app-item-image [item]="pos.item"></app-item-image>
                    </div>
                  </div>

                  <div class="flex flex-col justify-between w-full">
                    <div class="grid grid-cols-6 gap-2 mt-6 w-full">
                      <div class="col-span-6 lg:col-span-4">
                        <h3 class="text-sm w-full">
                          <a [routerLink]="['/shop/item/', pos._slug]" class="font-bold text-gray-700 hover:text-gray-800">{{
                            pos.designation | i18n
                          }}</a>
                        </h3>

                        <div class="mt-1 flex text-sm">
                          <p class="text-gray-500 bbit-inner-html" [innerHTML]="pos.itemNumber"></p>
                        </div>

                        <p class="mt-4 flex space-x-2 text-sm text-gray-700">
                          <app-item-stock [stock]="pos.stock"></app-item-stock>
                        </p>
                      </div>

                      <div class="col-span-6 lg:col-span-2 flex flex-row justify-between">
                        <div>
                          <app-quantity-input
                            [quantity]="pos.quantity"
                            (quantityChange)="cart.setPositionAmount(pos.item, $event)"
                            [stock]="pos.stock"
                          ></app-quantity-input>
                        </div>
                        <div class="col-span-3 lg:col-span-2">
                          @if (pos.amountExclVat.amount || pos.amountInclVat.amount) {
                            @if (((cart.observeLoadingPositions() | async) || []).includes(pos.item)) {
                              <app-loading [hideText]="true" [noWhitespace]="true" [classes]="['mt-1', 'h-6', 'w-6']"></app-loading>
                            } @else {
                              <p class="mt-2 text-sm font-bold text-gray-900 text-right">
                                @if (cart.observeIsVatInclusive() | async) {
                                  {{ pos.amountInclVat | bbitFormatPrice }}
                                } @else {
                                  {{ pos.amountExclVat | bbitFormatPrice }}
                                }
                              </p>
                            }
                          }
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-row justify-end w-full mt-6 mb-6">
                      <button
                        class="text-xs text-gray-600 flex flex-row items-center hover:text-primary-500"
                        (click)="cart.removePosition(pos.item)"
                      >
                        <span>{{ { key: 'remove' } | i18n }}</span>
                        <ng-icon name="heroTrash" size="16px" class="ml-2"></ng-icon>
                      </button>
                    </div>
                  </div>
                </li>
              }
            </ul>
          </section>

          <section class="border-t border-primary-600 mt-12">
            <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">
              {{ { key: 'shippingMethod', n: 1 } | i18n }}
            </h2>

            @if (cart.observePossibleShippingMethods() | async; as shippingMethods) {
              @if ((shippingMethods?.length || 0) > 0) {
                <fieldset class="p-4 relative">
                  @if (cart.observeAreShippingMethodsLoading() | async) {
                    <div
                      class="absolute z-10 top-0 left-0 bottom-0 right-0 bg-white bg-opacity-75 inset-0 flex items-center justify-center"
                    >
                      <app-loading [noWhitespace]="true" [hideText]="true"></app-loading>
                    </div>
                  }
                  <div class="space-y-5">
                    @for (o of shippingMethods; track o.shippingMethodConfig) {
                      <div class="relative flex items-start w-full">
                        <div class="flex h-6 items-center">
                          <input
                            [id]="'shipping-method-' + o.shippingMethodConfig"
                            [name]="'shipping-method-' + o.shippingMethodConfig"
                            type="radio"
                            [checked]="o.shippingMethodConfig === (cart.observeShippingMethodConfig() | async)"
                            (change)="cart.setShippingMethodConfig(o.shippingMethodConfig)"
                            class="h-4 w-4 border-gray-300 text-primary-600 focus:ring-primary-600"
                          />
                        </div>
                        <div class="ml-3 w-full text-sm leading-6 flex items-center justify-between">
                          <div>
                            <label [for]="'shipping-method-' + o.shippingMethodConfig" class="font-medium text-gray-900">{{
                              { object: o.designation } | i18n
                            }}</label>
                          </div>
                          <div class="text-sm font-bold text-gray-900">
                            {{ o.priceInclVat | bbitFormatPrice }}
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </fieldset>
              } @else {
                <div class="border border-primary-600 p-4 rounded-md m-4 text-sm flex flex-col md:flex-row md:space-x-4 items-center">
                  <ng-icon name="heroExclamationTriangle" size="24px" class="mb-2 md:mb-0"></ng-icon>
                  <p class="m-0 text-center md:text-left">
                    {{ { key: 'noShippingMethodsAvailable' } | i18n }}
                  </p>
                </div>
              }
            }
          </section>

          @if (cart.areCreditNotesAllowed()) {
            @if (
              ((cart.observeAvailableCreditNotes() | async)?.length || 0) > 0 ||
              ((cart.observeAppliedCreditNotes() | async)?.length || 0) > 0
            ) {
              @if ((cart.observeIsPaymentMethodRequired() | async) || ((cart.observeAppliedCreditNotes() | async)?.length || 0) > 0) {
                <section class="border-t border-primary-600 mt-12">
                  <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">
                    {{ { key: 'creditNote' } | i18n }}
                  </h2>
                  <div class="space-y-4 p-4 relative">
                    @if (cart.observeAreCreditNotesLoading() | async) {
                      <div
                        class="absolute z-10 top-0 left-0 bottom-0 right-0 bg-white bg-opacity-75 inset-0 flex items-center justify-center"
                      >
                        <app-loading [noWhitespace]="true" [hideText]="true"></app-loading>
                      </div>
                    }
                    @if (cart.observeIsPaymentMethodRequired() | async) {
                      @if (cart.observeAvailableCreditNotes() | async; as creditNotes) {
                        @if ((creditNotes?.length || 0) > 0) {
                          <div class="flex flex-col gap-2">
                            <div class="block text-sm font-medium leading-6 text-gray-900 mb-2">Verfügbare Gutschriften</div>
                            @for (creditNote of creditNotes; track creditNote._id) {
                              <div class="flex flex-row justify-between items-center gap-4">
                                <div class="text-sm text-gray-700">
                                  {{ creditNote.designation | i18n }} ({{ creditNote.amount | bbitFormatPrice }})
                                </div>
                                <button
                                  class="text-xs text-gray-600 flex flex-row items-center hover:text-primary-500"
                                  (click)="cart.applyCreditNote(creditNote._id)"
                                >
                                  <span>{{ { key: 'useCreditNote' } | i18n }}</span>
                                  <ng-icon name="heroPlus" size="16px" class="ml-2"></ng-icon>
                                </button>
                              </div>
                            }
                          </div>
                        }
                      }
                    }
                    @if (cart.observeAppliedCreditNotes() | async; as creditNotes) {
                      @if ((creditNotes?.length || 0) > 0) {
                        <div class="flex flex-col gap-2">
                          <div class="block text-sm font-medium leading-6 text-gray-900 mb-2">Bereits hinzugefügte Gutschriften</div>
                          @for (creditNote of creditNotes; track creditNote._id) {
                            <div class="flex flex-row justify-between items-center gap-4">
                              <div class="text-sm text-gray-700">
                                {{ creditNote.designation | i18n }} ({{ creditNote.amount | bbitFormatPrice }})
                              </div>
                              <button
                                class="text-xs text-gray-600 flex flex-row items-center hover:text-primary-500"
                                (click)="cart.removeCreditNote(creditNote._id)"
                              >
                                <span>{{ { key: 'remove' } | i18n }}</span>
                                <ng-icon name="heroTrash" size="16px" class="ml-2"></ng-icon>
                              </button>
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                </section>
              }
            }
          }

          @if (cart.areVouchersAllowed()) {
            @if ((cart.observeIsPaymentMethodRequired() | async) || ((cart.observeAppliedVouchers() | async)?.length || 0) > 0) {
              <section class="border-t border-primary-600 mt-12">
                <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">
                  {{ { key: 'voucher' } | i18n }}
                </h2>
                <div class="space-y-4 p-4 relative">
                  @if (cart.observeAreVouchersLoading() | async) {
                    <div
                      class="absolute z-10 top-0 left-0 bottom-0 right-0 bg-white bg-opacity-75 inset-0 flex items-center justify-center"
                    >
                      <app-loading [noWhitespace]="true" [hideText]="true"></app-loading>
                    </div>
                  }
                  @if (cart.observeIsPaymentMethodRequired() | async) {
                    <div class="flex flex-col gap-4 mb-4">
                      <div class="w-full">
                        <label for="voucherInput" class="block text-sm font-medium leading-6 text-gray-900"> Gutschein-Code </label>
                        <div class="mt-2">
                          <input
                            type="text"
                            name="voucherInput"
                            id="voucherInput"
                            class="text-sm block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                            [placeholder]="'Tippen Sie Ihren Gutschein-Code hier ein...'"
                            [ngModel]="cart.observeVoucherInput() | async"
                            (ngModelChange)="cart.setVoucherInput($event)"
                          />
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="rounded-md border border-transparent bg-primary-600 py-3 px-4 text-sm text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                        (click)="cart.applyVoucher()"
                      >
                        Gutschein hinzufügen
                      </button>
                    </div>
                  }
                  @if (cart.observeAppliedVouchers() | async; as vouchers) {
                    @if ((vouchers?.length || 0) > 0) {
                      <div class="flex flex-col gap-2">
                        <div class="block text-sm font-medium leading-6 text-gray-900 mb-2">Bereits hinzugefügte Gutscheine</div>
                        @for (voucher of vouchers; track voucher._id) {
                          <div class="flex flex-row justify-between items-center gap-4">
                            <div class="text-sm text-gray-700">
                              {{ voucher.designation | i18n }} ({{ voucher.amount | bbitFormatPrice }})
                            </div>
                            <button
                              class="text-xs text-gray-600 flex flex-row items-center hover:text-primary-500"
                              (click)="cart.removeVoucher(voucher._id)"
                            >
                              <span>{{ { key: 'remove' } | i18n }}</span>
                              <ng-icon name="heroTrash" size="16px" class="ml-2"></ng-icon>
                            </button>
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
              </section>
            }
          }

          @if (cart.observeIsPaymentMethodRequired() | async) {
            <section class="border-t border-primary-600 mt-12">
              <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">
                {{ { key: 'paymentMethod', n: 1 } | i18n }}
              </h2>

              @if (cart.observePossiblePaymentMethods() | async; as paymentMethods) {
                @if ((paymentMethods?.length || 0) > 0) {
                  <fieldset class="relative p-4">
                    @if (cart.observeArePaymentMethodsLoading() | async) {
                      <div
                        class="absolute z-10 top-0 left-0 bottom-0 right-0 bg-white bg-opacity-75 inset-0 flex items-center justify-center"
                      >
                        <app-loading [noWhitespace]="true" [hideText]="true"></app-loading>
                      </div>
                    }

                    <div class="space-y-5">
                      @for (o of paymentMethods; track o.paymentMethodConfig) {
                        <div class="relative flex items-start w-full">
                          <div class="flex h-6 items-center">
                            <input
                              [id]="'payment-method-' + o.paymentMethodConfig"
                              [name]="'payment-method-' + o.paymentMethodConfig"
                              type="radio"
                              [checked]="o.paymentMethodConfig === (cart.observePaymentMethodConfig() | async)"
                              (change)="cart.setPaymentMethodConfig(o.paymentMethodConfig)"
                              class="h-4 w-4 border-gray-300 text-primary-600 focus:ring-primary-600"
                            />
                          </div>
                          <div class="ml-3 w-full text-sm leading-6 flex items-center justify-between">
                            <div>
                              <label [for]="'payment-method-' + o.paymentMethodConfig" class="font-medium text-gray-900">{{
                                { object: o.designation } | i18n
                              }}</label>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </fieldset>
                }
              } @else {
                <div class="border border-primary-600 p-4 rounded-md m-4 text-sm flex flex-col md:flex-row md:space-x-4 items-center">
                  <ng-icon name="heroExclamationTriangle" size="24px" class="mb-2 md:mb-0"></ng-icon>
                  <p class="m-0 text-center md:text-left">
                    {{ { key: 'noPaymentMethodsAvailable' } | i18n }}
                  </p>
                </div>
              }
            </section>
          }

          <section class="border-t border-primary-600 mt-12">
            <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">
              {{ { key: 'summary' } | i18n }}
            </h2>

            <div class="relative">
              @if (cart.observeIsSummaryLoading() | async) {
                <div class="absolute z-10 top-0 left-0 bottom-0 right-0 bg-white bg-opacity-75 inset-0 flex items-center justify-center">
                  <app-loading [noWhitespace]="true" [hideText]="true"></app-loading>
                </div>
              }
              <dl class="mt-6 p-4">
                @for (o of cart.observeSummary() | async; track o) {
                  <div class="flex items-center justify-between p-2 hover:bg-gray-100 rounded-sm" [class.border-b]="o.hasBorder">
                    <dt class="text-sm text-gray-600" [class.text-gray-900]="o.isBold" [class.font-bold]="o.isBold">
                      {{ o.designation | i18n }}
                    </dt>
                    <dd class="text-sm text-gray-600" [class.text-gray-900]="o.isBold" [class.font-bold]="o.isBold">
                      {{ o.amount | bbitFormatPrice }}
                    </dd>
                  </div>
                }
              </dl>

              <div class="space-y-4">
                @if (cart.isCustomerReferenceInfoAllowed()) {
                  <div class="p-4">
                    <label for="customerReferenceInfo" class="block text-sm font-medium leading-6 text-gray-900">{{
                      { key: 'yourReference', n: 1 } | i18n
                    }}</label>
                    <div class="mt-2">
                      <input
                        type="text"
                        name="customerReferenceInfo"
                        id="customerReferenceInfo"
                        class="text-sm block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                        [placeholder]="{ key: 'yourReferenceInfo', n: 1 } | i18n"
                        [ngModel]="cart.observeCustomerReferenceInfo() | async"
                        (ngModelChange)="cart.setCustomerReferenceInfo($event)"
                      />
                    </div>
                  </div>
                }
                @if (cart.isCustomerInfoAllowed()) {
                  <div class="p-4">
                    <label for="customerInfo" class="block text-sm font-medium leading-6 text-gray-900">{{
                      { key: 'cartComment', n: 1 } | i18n
                    }}</label>
                    <div class="mt-2">
                      <textarea
                        rows="4"
                        name="customerInfo"
                        id="customerInfo"
                        class="text-sm block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                        [placeholder]="{ key: 'cartCommentInfo', n: 1 } | i18n"
                        [ngModel]="cart.observeCustomerInfo() | async"
                        (ngModelChange)="cart.setCustomerInfo($event)"
                      ></textarea>
                    </div>
                  </div>
                }
              </div>

              <div class="p-4">
                @if (cart.observeRequiredLegalFiles() | async; as legalDocs) {
                  @if ((legalDocs?.length || 0) > 0) {
                    <div class="mt-12 text-sm">
                      <div class="mb-4">
                        {{ { key: 'termsAndConditionsInfo' } | i18n }}
                      </div>
                      <div class="space-y-4">
                        @for (o of legalDocs; track o.file._id) {
                          <div class="flex items-center justify-start">
                            <input
                              [id]="o.file._id"
                              type="checkbox"
                              class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                              (change)="cart.toggleLegalFileAcceptance(o.file)"
                              [checked]="o.accepted"
                            />
                            <div class="flex flex-row justify-between w-full">
                              <label
                                [for]="o.file._id"
                                class="ml-3 whitespace-nowrap text-sm font-medium text-gray-900 flex flex-row justify-between overflow-hidden text-ellipsis"
                                ><span class="overflow-hidden text-ellipsis">{{ o.file.designation || '' | i18n }}</span>
                              </label>
                              <a
                                [href]="cart.getLegalFileUrl(o.file)"
                                [download]="(o.file.designation || '' | i18n) + '.pdf'"
                                target="_blank"
                                class="text-primary-600 hover:text-primary-800 ml-2 flex flex-row items-center"
                              >
                                <ng-icon name="heroArrowDownRight" class="mr-1.5 h-5 w-5 flex-shrink-0" size="16px"></ng-icon>
                                <span class="hidden md:block">{{ { key: 'download' } | i18n }}</span>
                              </a>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
                @if (cart.observeIsValid() | async) {
                  @if (cart.observeIsOrdering() | async) {
                    <div class="mt-12">
                      <button
                        type="submit"
                        class="text-sm w-full rounded-md border border-transparent bg-primary-600 py-3 px-4 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                        disabled
                      >
                        <app-loading [noWhitespace]="true" [hideText]="true" [classes]="['h-6', 'w-6', 'mx-auto']"></app-loading>
                      </button>
                    </div>
                  } @else {
                    <div class="mt-12">
                      <button
                        type="submit"
                        class="text-sm w-full rounded-md border border-transparent bg-primary-600 py-3 px-4 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                        (click)="cart.order()"
                      >
                        {{ { key: 'doOrder' } | i18n }}
                      </button>
                    </div>
                  }
                } @else {
                  <div class="mt-12">
                    <button
                      class="text-sm cursor-not-allowed w-full rounded-md border border-transparent bg-gray-300 py-3 px-4 text-white shadow-sm focus:outline-none focus:ring-offset-2 focus:ring-offset-gray-50"
                    >
                      {{ { key: 'doOrder' } | i18n }}
                    </button>
                  </div>
                }
                <!-- } @else {
                  <div class="border border-primary-600 p-4 rounded-md mt-4 text-sm flex flex-col md:flex-row md:space-x-4 items-center">
                    <ng-icon name="heroExclamationTriangle" size="24px" class="mb-2 md:mb-0"></ng-icon>
                    <p class="m-0 text-center md:text-left">
                      {{ { key: 'cartLoginRequired' } | i18n }}
                    </p>
                  </div>
                  <button
                    class="mt-4 w-full rounded-md border border-transparent bg-primary-600 py-3 px-4 text-base font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                    (click)="website.login()"
                  >
                    Login
                  </button>
                } -->
              </div>
            </div>
          </section>
        </form>
      } @else {
        <p>{{ { key: 'cartIsEmpty' } | i18n }}</p>
      }
    }
  } @else {
    <div class="flex flex-col gap-4 text-sm p-4 border border-primary-600 rounded-md bg-primary-600 bg-opacity-5">
      <div class="flex flex-row gap-4 items-center">
        <ng-icon name="heroInformationCircle" size="24px" class="flex-shrink-0 text-primary-600"></ng-icon>
        <div>{{ { key: 'tempCartInfo' } | i18n }}</div>
      </div>
      <div>
        <button
          type="submit"
          class="w-full rounded-md border border-transparent bg-primary-600 py-3 px-4 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
          (click)="website.login()"
        >
          Login
        </button>
      </div>
    </div>

    <form class="mt-12 w-full">
      <section aria-labelledby="cart-heading" class="mb-6">
        <ul role="list" class="divide-y divide-gray-200 border-b border-gray-200 last:border-b-0">
          @for (pos of cart.observeLocalPositions() | async; track pos._id; let i = $index) {
            <li class="flex flex-col md:flex-row gap-4">
              <div class="h-full w-full md:w-48 flex flex-col justify-center items-center">
                <div class="mr-6 h-32 w-48 max-h-32 max-w-48 mt-8 overflow-hidden">
                  <app-item-image class="h-full w-full" [item]="pos._id"></app-item-image>
                </div>
              </div>

              <div class="flex flex-col justify-between w-full">
                <div class="grid grid-cols-6 gap-2 mt-6 w-full">
                  <div class="col-span-6 lg:col-span-4">
                    <h3 class="text-sm w-full">
                      <a [routerLink]="['/shop/item/', pos.meta._slug]" class="font-bold text-gray-700 hover:text-gray-800">{{
                        { object: pos.item.designation } | i18n
                      }}</a>
                    </h3>

                    <div class="mt-1 flex text-sm">
                      <p class="text-gray-500 bbit-inner-html" [innerHTML]="pos.item.itemNumber"></p>
                    </div>

                    <p class="mt-4 flex space-x-2 text-sm text-gray-700">
                      <app-item-stock [stock]="pos.meta.stock"></app-item-stock>
                    </p>
                  </div>

                  <div class="col-span-6 lg:col-span-2 flex flex-row justify-between">
                    <div>
                      <app-quantity-input
                        [quantity]="pos.quantity"
                        (quantityChange)="cart.setPositionAmount(pos.item._id, $event)"
                        [stock]="pos.meta.stock"
                      ></app-quantity-input>
                    </div>
                    <div class="col-span-3 lg:col-span-2">
                      <app-item-price [price]="pos.meta.price"></app-item-price>
                    </div>
                  </div>
                </div>
                <div class="flex flex-row justify-end w-full mt-6 mb-6">
                  <button
                    class="text-xs text-gray-600 flex flex-row items-center hover:text-primary-500"
                    (click)="cart.removePosition(pos.item._id)"
                  >
                    <span>{{ { key: 'remove' } | i18n }}</span>
                    <ng-icon name="heroTrash" size="16px" class="ml-2"></ng-icon>
                  </button>
                </div>
              </div>
            </li>
          } @empty {
            <p>{{ { key: 'cartIsEmpty' } | i18n }}</p>
          }
        </ul>
      </section>
    </form>
  }
</div>
